import React from 'react';
import { Button, Grid, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { PlanningCycleCreatePayload } from './planningCycle.models';

type Option = { rid?: number; id?: number; shc?: string; code?: string; nam?: string; name?: string };

type Props = {
  budgetPeriods: Option[];
  loading?: boolean;
  onCreate: (payload: PlanningCycleCreatePayload) => Promise<void>;
};

type State = PlanningCycleCreatePayload;

class PlanningCycleCreatePanel extends React.Component<Props, State> {
  state: State = { budgetperiodid: 0, name: '', description: '' };

  idOf = (x: Option) => Number(x.rid ?? x.id ?? 0);
  nameOf = (x: Option) => x.nam ?? x.name ?? x.shc ?? x.code ?? '';

  submit = async () => {
    if (!this.state.budgetperiodid) return;
    await this.props.onCreate(this.state);
    this.setState({ budgetperiodid: 0, name: '', description: '' });
  };

  render() {
    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Stack spacing={2}>
          <div>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>Create Planning Cycle</Typography>
            <Typography variant="body2" color="text.secondary">
              Create the budget-domain cycle first. Executive Review and Determinant Budget reference it later.
            </Typography>
          </div>

          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                select
                size="small"
                label="Budget Period"
                value={this.state.budgetperiodid || ''}
                onChange={(e) => this.setState({ budgetperiodid: Number(e.target.value) })}
                fullWidth
              >
                {this.props.budgetPeriods.map((x) => (
                  <MenuItem key={this.idOf(x)} value={this.idOf(x)}>{this.nameOf(x)}</MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
              <TextField size="small" label="Cycle Name" value={this.state.name}
                onChange={(e) => this.setState({ name: e.target.value })} fullWidth />
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <TextField size="small" label="Description" value={this.state.description}
                onChange={(e) => this.setState({ description: e.target.value })} fullWidth />
            </Grid>

            <Grid size={{ xs: 12, md: 2 }}>
              <Button variant="contained" startIcon={<AddIcon />} onClick={this.submit}
                disabled={this.props.loading || !this.state.budgetperiodid} fullWidth>
                Create
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Paper>
    );
  }
}

export default PlanningCycleCreatePanel;
